import { ApiProperty } from '@nestjs/swagger'
import { IsEmail, IsNotEmpty, IsNotEmptyObject, IsString, Length } from 'class-validator'
import { CreateUserWithPasswordRequest } from '../../user'

export class CompanyResponse {
	@ApiProperty({ type: String, format: 'uuid' })
	id: string

	@ApiProperty({ type: String })
	name: string

	@ApiProperty({ type: String, format: 'email' })
	email: string

	@ApiProperty({ type: Boolean })
	emailVerified: boolean
}

export class CreateTenantWithUserRequest {
	@ApiProperty({ type: String })
	@IsNotEmpty()
	@IsString()
	verificationToken: string

	@ApiProperty({ type: String })
	@IsNotEmpty()
	@IsString()
	@Length(2, 60)
	companyName: string

	@ApiProperty({ type: String })
	@IsNotEmpty()
	@IsString()
	@Length(3, 3)
	currencyCode: string

	@ApiProperty({ type: String })
	@IsNotEmpty()
	@IsString()
	@IsEmail()
	contactEmail: string

	@ApiProperty({ type: String })
	@IsNotEmpty()
	@IsString()
	address: string

	@ApiProperty({ type: String })
	@IsString()
	googlePlaceId: string

	@ApiProperty({ type: String })
	@IsString()
	timezone: string

	@ApiProperty({ type: CreateUserWithPasswordRequest })
	@IsNotEmptyObject()
	user: CreateUserWithPasswordRequest
}
